// Feature card component
import {useColorModeValue, chakra, Icon, Heading, Text} from "@chakra-ui/react";
import {motion} from "framer-motion";

export default function FeatureCard({ icon: IconComponent, title, desc }) {
    const cardBg = useColorModeValue('white', 'gray.700')
    const accent = useColorModeValue('teal.300', 'blue.300')
    const titleColor = useColorModeValue('gray.800', 'white')
    const descColor = useColorModeValue('gray.600', 'gray.300')

    const MotionBox = motion(chakra.div)

    return (
        <MotionBox
            bg={cardBg}
            p={8}
            rounded="2xl"
            shadow="xl"
            whileHover={{ scale: 1.05, boxShadow: '0 10px 25px rgba(0,0,0,0.1)' }}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            textAlign="center"
        >
            <Icon as={IconComponent} w={12} h={12} color={accent} mb={4} />
            <Heading size="lg" mb={2} color={titleColor}>
                {title}
            </Heading>
            <Text color={descColor}>{desc}</Text>
        </MotionBox>
    )
}